import { useState } from "react";
import { Button, Collapse, Nav, NavItem, Navbar, NavbarToggler } from "reactstrap";
import { logout } from "../model/login";

interface PublicNavbarProps {
  isAuthenticated: boolean;
}

export const PublicNavbar = (props: PublicNavbarProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const iamActive = (href: string) => {
    let url = window.location.href;
    return url.indexOf(href) !== -1;
  };

  const close = () => setIsOpen(false);

  return (
    <Navbar expand="lg" className="navbar-expand-lg">
      <a className="navbar-brand" href="/">
        <img src="/images/logo.png" width="150" alt="Acader Pty Ltd" />
      </a>
      <NavbarToggler onClick={() => setIsOpen((x) => !x)} aria-label="Toggle navigation" />
      <Collapse isOpen={isOpen} navbar>
        <Nav className="me-auto mt-2 mt-lg-0" navbar>
          <NavItem>
            <a className="nav-link" href="https://darci.ai" target="_blank" rel="noreferrer">
              DARCI.AI
            </a>
          </NavItem>
          <NavItem className={iamActive("/#services") ? "active" : ""}>
            <a className="nav-link" href="/#services" id="nav-services" onClick={close}>
              Services
            </a>
          </NavItem>
          <NavItem className={iamActive("/#clients") ? "active" : ""}>
            <a className="nav-link" href="/#clients" id="nav-clients" onClick={close}>
              Clients
            </a>
          </NavItem>
          <NavItem className={iamActive("/support") ? "active" : ""}>
            <a className="nav-link" href="/support" id="nav-support" onClick={close}>
              Support
            </a>
          </NavItem>
          <NavItem className={iamActive("/#aboutus") ? "active" : ""}>
            <a className="nav-link" href="/#aboutus" id="nav-about" onClick={close}>
              About us
            </a>
          </NavItem>
          <NavItem className={iamActive("/#contactus") ? "active" : ""}>
            <a className="nav-link" href="/#contactus" id="nav-contact" onClick={close}>
              Contact us
            </a>
          </NavItem>
          {props.isAuthenticated && (
            <NavItem>
              <a className="nav-link" href="/timesheet" id="nav-timesheet" onClick={close}>
                Timesheet
              </a>
            </NavItem>
          )}
        </Nav>
        {props.isAuthenticated ? (
          <Button className="nav-cta my-2 my-lg-0" onClick={() => logout()} id="p-logout">
            <i className="fas fa-sign-out-alt me-1"></i>
            Logout
          </Button>
        ) : (
          <a href="/login" id="p-login" className="nav-cta my-2 my-lg-0">
            <i className="fas fa-sign-in-alt me-1"></i>
            Login
          </a>
        )}
      </Collapse>
    </Navbar>
  );
};
